import koSchema from '@bingads-webui-component-legacy/ko-schema/index';

const s$AdGroup = window.globalLegacySchema.get('AdGroup');

export default class ViewModel {
  constructor({
    campaignName = '',
  } = {}) {
    koSchema.properties(this, s$AdGroup, ['Name', 'Language']);
    this.campaignName = campaignName;
  }
}
